import type { CSSProperties, JSX } from 'react';

import classNames from 'classnames';

import { useAnchorable } from '../../hooks/useAnchorable';

import { baseHeading, headingContainer, hTagStyleMap } from './Heading.css';
import type { PostHeadingProps } from './Heading.types';

export {
  baseHeading as postBaseHeadingClass,
  headingContainer as postHeadingContainerClass,
  hTagStyleMap as postHeadingTagStyleMap,
} from './Heading.css';

export const PostHeading = ({
  element,
  children, // we don't want these extra props in the ...props rest since we're spreading it on a div
  isLive,
  isIndexingDisabled,
  rewriteImageSrc,
  homePath,
  loginPath,
  subscribePath,
  isSubscriberAuthenticated,
  ...props
}: PostHeadingProps) => {
  const { level = 1, textAlign } = element.attrs;
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;
  const { anchorAttributes } = useAnchorable(element.attrs);

  return (
    <div
      {...anchorAttributes}
      className={headingContainer}
      style={
        {
          '--text-align': textAlign,
        } as CSSProperties
      }
    >
      {/* spreading props on standard DOM elements causes React warnings and hydration errors */}
      <Tag {...props} className={classNames(baseHeading, hTagStyleMap[`h${level}`])}>
        {children}
      </Tag>
    </div>
  );
};
